import { useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';
import { goalsGuideService } from '../api/goals-guide';

/**
 * Fetches the localized "Situation and goals" screen copy from the API. The
 * locale is part of the query key so an in-app language switch refetches the
 * right translation. Copy is static, so it caches for a long time.
 */
export function useProjectGoalsGuide() {
  const locale = useLocale();
  return useQuery({
    queryKey: ['content', 'project-goals-guide', locale],
    queryFn: () => goalsGuideService.get(),
    staleTime: 1000 * 60 * 60, // 1h — static localized copy
  });
}
